import React, { Component } from 'react';
import Tree, { TreeNode } from 'rc-tree';
import classNames from 'classnames';
import styles from './style.scss';

export default class TreeView extends Component {

    constructor(props){
        super(props);
    };

    onHover = (e) => {

        //ReactDOM.findDOMNode(this.refs.treeNode).style.backgroundColor = 'blue';
    }

    onLeave = (e) => {

        //ReactDOM.findDOMNode(this.refs.treeNode).style.backgroundColor = '';
    }

    render() {

        const loop = node => {
            
            return node.map((item) => {

                if (item.children && item.children.length) {

                  item.children.sort(this.props.sortingFunction);

                    return <TreeNode
                                key={item.key}
                                chec
                                title={item.title}
                                ref={'treeNode'}
                                className={classNames(styles.treeNode)}
                            >
                                {loop(item.children)}
                            </TreeNode>;
                }
              
                return <TreeNode 
                    key={item.key} 
                    title={item.title} 
                    ref={'treeNode'} />;
            });
          };

        return <div
                    className='draggable-container'
                    data-cy={this.props.dataCy}
                >
                    <Tree
                        onMouseEnter={this.onHover}
                        onMouseLeave={this.onLeave}
                        checkStrictly={this.props.checkStrictly}
                        onCheck={this.props.checkedHandler}
                        checkable={this.props.checkable}
                        selectable={this.props.selectable}
                        draggable={this.props.draggable}
                        selectedKeys={this.props.selectedKeys}
                        checkedKeys={this.props.checkedKeys}
                        defaultExpandAll={this.props.defaultExpandAll}
                        expandedKeys={this.props.expandedKeys ? this.props.expandedKeys : []}
                        defaultExpandedKeys={this.props.defaultExpandedKeys ? this.props.defaultExpandedKeys : []}
                        filterTreeNode={this.props.filterTreeNode}
                        onSelect={this.props.onSelect}
                        className={this.props.className}
                        showLine={true}
                        multiple={this.props.multiple}
                        onDragStart={this.props.onDragStart}
                        onDragEnter={this.props.onDragEnter}
                        onDrop={this.props.onDrop}
                        onRightClick={this.props.onRightClick}
                        onExpand = {this.props.onExpand}
                        defaultExpandParent = {this.props.defaultExpandParent}
                        >
                        {loop(this.props.nodes)}
                    </Tree>
                </div>;
    }
}
